

// `NEW`图标样式-主菜单
export const MenuClassName = (menu = {}) => {
  const {
    id = '',
  } = menu;
  let iconClassName = '';
  switch (id) {
    case '1347374258581753856': // 产品库
      // iconClassName = 'menu_icon_new_org';
      break;
    default:
      break;
  }
  return iconClassName;
}